import { namedRoutes, resolveRoutePath } from '../../bundles/routes';
import { Spinner } from '../../../../../../shared/frontend/components/presentational/spinner';
import { TeamRankingsTableLarge } from '../components/rankingsElements';
import { withTeamRankings } from './withTeamRankings';
import { TeamNamespace } from '../../../../shared/enums';

/* tslint:disable:max-line-length */

function TeamRankingsWidgetBase(props: any) {
  if (!props.response?.rankedTeams) {
    return (
      <div style={{ position: 'relative', padding: '10rem' }}>
        <Spinner />
      </div>
    );
  }

  const table = (
    <TeamRankingsTableLarge
      teamDetailsRoute={namedRoutes.TeamDetails}
      makeRankingsRoute={(params: any) => resolveRoutePath(namedRoutes.TeamLeaderboardPage, { ...props, ...params })}
      season={props.request.season}
      region={props.request.region}
      teams={props.response.rankedTeams}
      title={props.title}
      dungeons={props.dungeons}
      getTeamLink={(route: string, entry: any) =>
        resolveRoutePath(route, {
          namespace: TeamNamespace.MYTHICPLUS,
          team: entry.team.slug,
          region: entry.team.region.slug
        })
      }
      compact={true}
      footer={props.footer}
      config={{
        maxVisibleRuns: 5,
        columns: {
          dps: false,
          tank: false,
          healer: false,
          rank: true,
          teamName: true,
          score: true,
          faction: false,
          runs: false
        }
      }}
    />
  );

  return table;
}

export default withTeamRankings(TeamRankingsWidgetBase);
